import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Check } from "lucide-react";
import FloatingOrbs from "@/components/effects/FloatingOrbs";
import { TID } from "@/constants/testIds";
import { PROFILE } from "@/data/content";

const ThankYou = () => {
    return (
        <main className="relative flex min-h-screen items-center justify-center overflow-hidden bg-brand-bg px-6">
            <FloatingOrbs />
            <div aria-hidden className="pointer-events-none absolute inset-0 grid-bg" />
            <div aria-hidden className="pointer-events-none absolute inset-0 grain" />

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                className="relative z-10 max-w-2xl text-center"
            >
                <motion.div
                    initial={{ scale: 0.5, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.7, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
                    className="mx-auto mb-8 grid h-16 w-16 place-items-center rounded-2xl border border-emerald-400/30 bg-emerald-400/10"
                >
                    <motion.span
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                    >
                        <Check className="h-8 w-8 text-emerald-300" />
                    </motion.span>
                </motion.div>

                <p className="overline">Thank you</p>
                <h1
                    className="mt-4 text-4xl font-semibold tracking-tighter text-white sm:text-5xl md:text-6xl"
                    style={{ fontFamily: "'General Sans', sans-serif" }}
                >
                    Message received.
                </h1>
                <p className="mx-auto mt-6 max-w-xl text-base text-brand-muted md:text-lg">
                    Thanks for reaching out. I&apos;ll get back to you personally, usually within a business day. A
                    confirmation email is on its way to your inbox.
                </p>

                <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
                    <Link
                        data-testid={TID.thankYouHome}
                        to="/"
                        className="btn-primary"
                    >
                        <ArrowLeft className="h-4 w-4" />
                        Back to home
                    </Link>
                    <a href={PROFILE.github} target="_blank" rel="noreferrer" className="btn-ghost">
                        View GitHub
                    </a>
                </div>
            </motion.div>
        </main>
    );
};

export default ThankYou;
